// extracted by mini-css-extract-plugin
module.exports = {"active":"tab_active__q0JS3","tabNav":"tab_tabNav__5QNJF","boto":"tab_boto__cRYw8"};